export class BusinessCode {
    timestamp: number; // Representa la fecha en formato timestamp
    code: string; // Representa el código alfanumérico de 12 dígitos

    constructor(timestamp: number, code: string) {
        this.timestamp = timestamp;
        this.code = code;
    }
}
